export function isLendioTestUser() {
    let userAgent = navigator.userAgent || ''
    userAgent = userAgent.toLowerCase()
    return userAgent.includes('lendio') && userAgent.includes('testuser');
}
